// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"573":"2b5ce69a","654":"48be18dc","668":"4c36bfc5","889":"69d768d1"}[chunkId] + ".chunk.css";
};